/**
 * Two-finger scanner support.
 *
 * Some supported scanners have a platen too small for a four-finger slap. On those, the operator
 * captures each hand as two half-slaps — index+middle, then ring+little — and the Device Service
 * composites them into the single slap the EBTS expects at FGP 13/14 (POST /captures/stitch). v1 did
 * this in the tenprint capture modal; without it, an operator on one of these devices simply cannot
 * complete a tenprint, because the flow asks for an impression the hardware can't take.
 *
 * Detection is by device-name prefix, matching v1. That is admittedly crude — a new two-finger model
 * would silently fall back to asking for a four-finger slap — but the supported hardware list is short
 * and controlled, so it is checked rather than inferred. Keep this list in sync with the Device Service's
 * supported devices.
 */
export const TWO_FINGER_DEVICE_PREFIXES = ['WATSON', 'DACTYSCAN40I'] as const;

/** True when the connected scanner needs half-slap capture + stitching. Case-insensitive. */
export function isTwoFingerScanner(deviceName?: string | null): boolean {
  const name = (deviceName ?? '').trim().toUpperCase();
  if (!name) return false;
  return TWO_FINGER_DEVICE_PREFIXES.some((p) => name.startsWith(p));
}
